import { TransitDocumentsEnum } from '@e-origin/shared';

export enum FormDocumentsInputType {
  NUMBER = 'NUMBER',
  INPUT = 'INPUT',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  MULTI_LANG = 'MULTI_LANG',
  DATE = 'DATE',
}

export type TransitDocumentFormSchemaProps = Record<
  string,
  {
    fields: Record<
      string,
      {
        type: FormDocumentsInputType;
        search?: (search: string, lang: string, isHeader?: boolean) => Promise<{ value: string; label: string }[]>;
        placeholder: string;
        code?: string;
        show?: (isArrival?: boolean, forGoodsItem?: boolean) => boolean;
        disabled?: (isArrival?: boolean) => boolean;
        'data-pw'?: string;
      }
    >;
  }
>;

const PLACEHOLDERS = {
  REFERENCE_NUMBER: 'Reference Number',
  TYPE: 'Type',
  COMPLEMENT_OF_INFORMATION: 'Complement Of Information',
};

export const TransitDocumentFormSchema: TransitDocumentFormSchemaProps = {
  [TransitDocumentsEnum.PREVIOUS_DOCUMENT]: {
    fields: {
      type: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL214',
        placeholder: PLACEHOLDERS.TYPE,
        'data-pw': 'type-input',
      },
      referenceNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.REFERENCE_NUMBER,
        'data-pw': 'reference-number-input',
      },
      goodsItemNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: 'Goods item identifier',
        show: (_, forGoodsItem) => !!forGoodsItem,
      },
      typeOfPackages: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL017',
        placeholder: 'Type of packages',
        show: (_, forGoodsItem) => !!forGoodsItem,
      },
      numberOfPackages: {
        type: FormDocumentsInputType.INPUT,
        placeholder: 'Number of packages',
        show: (_, forGoodsItem) => !!forGoodsItem,
      },
      measurementUnitAndQualifier: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL349',
        placeholder: 'Measurement unit and qualifier',
        show: (_, forGoodsItem) => !!forGoodsItem,
      },
      quantity: {
        type: FormDocumentsInputType.INPUT,
        placeholder: 'Quantity',
        show: (_, forGoodsItem) => !!forGoodsItem,
      },
      complementOfInformation: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.COMPLEMENT_OF_INFORMATION,
        'data-pw': 'complement-of-information-input',
      },
    },
  },
  [TransitDocumentsEnum.SUPPORTING_DOCUMENT]: {
    fields: {
      type: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL213',
        placeholder: PLACEHOLDERS.TYPE,
        'data-pw': 'type-input',
      },
      referenceNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.REFERENCE_NUMBER,
        'data-pw': 'reference-number-input',
      },
      documentLineItemNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: 'Document Line Item Number',
        show: (isArrival: boolean): boolean => !isArrival,
      },
      complementOfInformation: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.COMPLEMENT_OF_INFORMATION,
        disabled: (isArrival: boolean): boolean => isArrival,
      },
    },
  },
  [TransitDocumentsEnum.TRANSPORT_DOCUMENT]: {
    fields: {
      type: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL754',
        placeholder: PLACEHOLDERS.TYPE,
      },
      referenceNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.REFERENCE_NUMBER,
      },
    },
  },
  [TransitDocumentsEnum.ADDITIONAL_REFERENCE]: {
    fields: {
      type: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL380',
        placeholder: PLACEHOLDERS.TYPE,
      },
      referenceNumber: {
        type: FormDocumentsInputType.INPUT,
        placeholder: PLACEHOLDERS.REFERENCE_NUMBER,
      },
    },
  },
  [TransitDocumentsEnum.ADDITIONAL_INFORMATION]: {
    fields: {
      code: {
        type: FormDocumentsInputType.MULTI_LANG,
        code: 'CL239',
        placeholder: 'Code',
      },
      text: {
        type: FormDocumentsInputType.INPUT,
        placeholder: 'Text',
      },
    },
  },
};
